import React from 'react';
import Logo from '../assets/logos/Logo';
import { AudioWaveLoadingIcon } from '../icons';

const AppLoadingScreen: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 dark:from-gray-900 dark:to-gray-800 flex items-center justify-center">
      <div className="text-center">
        {/* Logo with pulse animation */}
        <div className="mb-8 animate-pulse">
          <Logo className="h-16 w-auto mx-auto" />
        </div>

        {/* Loading spinner */}
        <div className="flex justify-center mb-4">
          <AudioWaveLoadingIcon
            size={32}
            className="text-blue-500 dark:text-blue-400"
          />
        </div>

        {/* Loading text */}
        {/* <p className="text-gray-600 text-lg font-medium">Loading VeriVox...</p> */}
      </div>
    </div>
  );
};

export default AppLoadingScreen;
